angular.module('unergie.main')
.controller('newJiraModalCtrl', ($scope, $filter, $uibModalInstance, JiraService, AuthService, ApiAdmin, AlertManager, BoFeaturesService, ErrorCatcher, accounts) => {
    const auth = AuthService.getAuth()

    $scope.fetchRequestTypes = () => {
        $scope.loadingIssues = true
        return JiraService.getRequestTypes(auth.organization).then((requestTypes) => {
            $scope.newJiraIssue = JiraService.init(angular.fromJson(angular.toJson(requestTypes)), 'B2G', accounts)
            // dirty hack : on retire le type "Branchement provisoire" pour pas qu'ils puissent faire la demande ici
            $scope.newJiraIssue.fields.requestType.enum = _.filter($scope.newJiraIssue.fields.requestType.enum, (elem) => elem.label !== 'Branchement provisoire')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.loadingIssues = false
        })
    }

    $scope.fetchRequestTypes()


    $scope.confirmJiraIssueSubmit = () => {
        $scope.saving = true
        $scope.errorMsg = ''
        const jiraIssue = {
            summary: $scope.newJiraIssue.template.summary,
            description: $scope.newJiraIssue.template.description,
            type: 'Support',
            customfield_10801: $scope.newJiraIssue.template.prm,
            customfield_10802: $scope.newJiraIssue.template.brand.customer_id,
            enrichSummary: false,
            brand: $scope.newJiraIssue.template.brand.brand,
            requestType: $scope.newJiraIssue.template.requestType,
        }
        return ApiAdmin.createJiraIssue({ projectKey: auth.organization }, jiraIssue).$promise.then(() => {
            AlertManager.success('Demande créée')
            $scope.close()
        })
        .catch((err) => {
            AlertManager.error(`Une erreur est survenue lors de l'appel a JIRA ${err.data && `: ${err.data.message}`}`, 5000)
        })
        .finally(() => {
            $scope.saving = false
        })
    }

    $scope.canCreate = () => {
        return $scope.newJiraIssue &&
        $scope.newJiraIssue.template &&
        $scope.newJiraIssue.template.summary &&
        $scope.newJiraIssue.template.description &&
        $scope.newJiraIssue.template.requestType &&
        $scope.newJiraIssue.template.brand
    }

    // RETURN OK
    $scope.close = () => $uibModalInstance.close()

    $uibModalInstance.dismiss = $scope.ok
})
